import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useGameCache } from './cache'
import { type GameRemoveInput, type GameRemoveSuccess, Logger, toResponseError } from '@terros/common'

const logger = new Logger('useRemoveCompetition')

export function useRemoveCompetition(): RemoveHookResponse<GameRemoveInput> {
  logger.verbose('calling useRemoveCompetition')
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameRemoveInput, GameRemoveSuccess>({ url: '/game/remove' })

  async function remove(input: GameRemoveInput): Promise<void> {
    try {
      logger.verbose('starting remove')
      await mutation.mutateAsync(input)
      cache.clearItem(input.gameId)
      cache.clearListItem(input.gameId)
      logger.verbose('done with remove')
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
